import React from 'react';
import { Container, Grid, Switch, FormControlLabel } from '@material-ui/core';

import Spec from '../../../models/Spec';
import { useDialog } from '../../../context/Dialog';

interface Props {
  spec: Spec
  onSpecChange?: (spec: Spec) => void
}

const Settings = (props: Props) => {
  const { spec, onSpecChange = () => {} } = props;

  const { confirm } = useDialog();

  const setSpec = (setter: (_spec: Spec) => Spec) => {
    return onSpecChange(setter(spec));
  };

  const setFileMode = (value: boolean) => {
    const _spec = new Spec(spec);
    if (value) {
      confirm('File submission mode will remove all the test cases. Do you want to continue?').then(confirmed => {
        if (!confirmed) return;
        _spec.data = [];
        onSpecChange(_spec);
      });
    }
    else {
      _spec.addItem();
      onSpecChange(_spec);
    }
  };

  return (
    <Container>
      <Grid container spacing={3}>
        <Grid item xs={4} className="d-flex align-items-center justify-content-between">
          <FormControlLabel
            label="File Submit Mode"
            control={
              <Switch
                color="primary"
                checked={!spec.data?.length}
                onChange={() => {
                  setFileMode(!!spec.data?.length);
                }}
              />
            }
          />
        </Grid>

        <Grid item xs={4} className="d-flex align-items-center justify-content-between">
          <FormControlLabel
            label="Auto Grade"
            control={
              <Switch
                color="primary"
                checked={!spec.autoGradeOff}
                onChange={() => {
                  setSpec((state) => {
                    const _spec = new Spec(state);
                    _spec.autoGradeOff = !_spec.autoGradeOff;
                    return _spec;
                  });
                }}
              />
            }
          />
        </Grid>

        <Grid item xs={4} className="d-flex align-items-center justify-content-between">
          <FormControlLabel
            label="Show Test Cases"
            control={
              <Switch
                color="primary"
                checked={spec.showTestCase}
                onChange={() => {
                  setSpec((state) => {
                    const _spec = new Spec(state);
                    _spec.showTestCase = !_spec.showTestCase;
                    return _spec;
                  });
                }}
              />
            }
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Settings;